export default "__VITE_ASSET__CMeKZvci__"